import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from '@/components/edifice/App/App';

const rootElement = document.getElementById('root') as HTMLElement;

const stampedPath = document
    .querySelector('meta[name="x-prerender-path"]')
    ?.getAttribute('content');

const currentPath = window.location.pathname;

// hydrate only if DOM corresponds to this route
const shouldHydrate =
    rootElement.hasChildNodes() &&
    stampedPath != null &&
    stampedPath === currentPath;

if (shouldHydrate) {
    hydrateRoot(rootElement, <App />, {
        onRecoverableError(error) {
            console.error('[hydrate recoverable error]', error);
        },
    });
} else {
    createRoot(rootElement).render(<App />);
}
